module.exports = __webpack_public_path__ + "static/pakmaya-my-sm-d4afb5f8cb29324634d3acdf4ff6389a.jpg";